import { render } from "./DoctorCheckBox.vue?vue&type=template&id=1cd00354"
import script from "./DoctorCheckBox.vue?vue&type=script&lang=js"
export * from "./DoctorCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__